export default __webpack_public_path__ + "static/media/quem-somos.76d8b8b0.png";